import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { getCategoryList } from "store/features/groupBy/groupBySlice";

import { EntityKind } from "models/entityKind";

import { useUserDefaults } from "components/user/hooks";

export function useGetCategoryList() {
  const dispatch = useDispatch();
  const defaults = useUserDefaults();
  const unitType = defaults?.unitSetting?.unit ?? 0;
  const isReady = defaults !== undefined && defaults.unitSetting?.unit !== undefined;

  const getCategoryListWithUnit = useCallback(
    (entityKind?: EntityKind) => {
      if (!isReady) {
        return;
      }
      dispatch(getCategoryList(entityKind, unitType));
    },
    [dispatch, isReady, unitType]
  );

  return {
    getCategoryListWithUnit,
    isReady,
    unitType
  };
}
